var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticStyle: { overflow: "hidden" }, attrs: { row: "" } },
        [
          _c("v-flex", { attrs: { "hidden-sm-and-down": "" } }, [
            _c("iframe", {
              staticStyle: { height: "1000px" },
              attrs: {
                src:
                  "https://targetfirst.freshdesk.com/a/tickets/filters/all_tickets",
                width: "100%",
                height: "100%"
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38581a4e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38581a4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticketing/Freshdesk.vue
// module id = null
// module chunks = 